import { useEffect, useRef, useState } from "react"
import Popup from "@/app/components/popup"
import classNames from "classnames"

type Props = {
    src: string
    priority?: 'auto' | 'high' | 'low'
    containerClassName?: string
    imgClassName?: string
    loadingClassName?: string
    onLoad?: Function
    onError?: Function
    canZoom?: boolean
}

export default function LoadedImg(props: Props) {

    const {
        src, priority,
        containerClassName, imgClassName, loadingClassName,
        onLoad, onError, canZoom
    } = props
    const [ imgLoaded, setImgLoaded ] = useState(null)
    const [ zoom, setZoom ] = useState(false)
    const imgRef = useRef<HTMLImageElement>(null)

    useEffect(() => {
        setImgLoaded(null)
        imgRef.current = null
        if (src) {
            imgRef.current = new Image()
            imgRef.current.addEventListener('load', handleOnLoad, false)
            imgRef.current.addEventListener('error', handleOnError, false)
            imgRef.current.src = src

            return () => {
                imgRef.current.removeEventListener('load', handleOnLoad, false)
                imgRef.current.removeEventListener('error', handleOnError, false)
            }
        }
    }, [src])


    const handleOnLoad = () => {
        // console.log('img onLoad', src)
        setImgLoaded(true)
        onLoad && onLoad()
    }
    const handleOnError = () => {
        console.log('img onError', src)
        setImgLoaded(false)
        onError && onError()
    }

    if (src) return (
        <>
        <div className={classNames('relative full', containerClassName)}>
            <img
                src={src}
                className={classNames('full object-cover transition duration-700', imgClassName, {
                    'opacity-[1]': imgLoaded,
                    'opacity-[0]': !imgLoaded,
                    'cursor-pointer': canZoom && imgLoaded,
                })}
                fetchPriority={priority}
                onClick={() => {
                    if (canZoom) {
                        setZoom(true)
                    }
                }}
            />
            <div className={classNames('absolute top-0 full transition duration-700 pointer-events-none', {
                'opacity-[0]': imgLoaded,
                'opacity-[1]': !imgLoaded
            })}>
                <div className={classNames('full bg-gray-500 animate-pulse', loadingClassName)}></div>
            </div>
        </div>

        { zoom &&
            <Popup
                className="!p-4"
                contentClassName="!bg-[transparent] !p-0"
                close={() => {setZoom(false)}}
            >
                <img
                    src={src}
                    className="w-full border border-[3px] border-white rounded-[1rem]"
                />
            </Popup>
        }
        </>
    )
}